import {
  convertObjectKeysToSnakeCase,
  getWindowLocationValues,
} from './helpers'

/**
 * Track click events
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {string} event.elementId
 * @param {string} event.elementType
 * @param {object} event.metadata
 * @param {object} event.scope
 */
export function trackClickEvent(
  statsigClient,
  { elementId, elementType, metadata, scope },
) {
  statsigClient?.logEvent('click', elementId, {
    element_id: elementId,
    element_type: elementType,
    metadata: {
      ...convertObjectKeysToSnakeCase(metadata),
    },
    ...getWindowLocationValues(scope),
  })
}
